export const API_ERROR = "api_error"
export const API_INVALID_RESPONSE = "api_invalid_response"
